"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _I18n = _interopRequireDefault(require("I18n"));

var _react = _interopRequireWildcard(require("react"));

var _classNames = _interopRequireDefault(require("react-utils/classNames"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Style = require("../core/Style");

var _memoizeOne = _interopRequireDefault(require("react-utils/memoizeOne"));

var _sizes = require("HubStyleTokens/sizes");

var TShirtSize = _interopRequireWildcard(require("../utils/propTypes/tshirtSize"));

var _UIDialogButton = _interopRequireDefault(require("../dialog/UIDialogButton"));

function _templateObject3() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  fill: currentColor;\n  stroke: currentColor;\n  stroke-width: 2;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  color: inherit;\n  display: block;\n  flex-grow: 1;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  height: ", ";\n  position: absolute;\n  right: ", ";\n  width: ", ";\n\n  &::after {\n    padding: ", ";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var SIZE_OPTIONS = {
  small: {
    size: _sizes.SMALL_CLOSE_BUTTON_SIZE,
    padding: 12
  },
  medium: {
    size: _sizes.MEDIUM_CLOSE_BUTTON_SIZE,
    padding: 16
  },
  large: {
    size: _sizes.MODAL_CLOSE_BUTTON_SIZE,
    padding: 20
  },
  'extra-large': {
    size: _sizes.EXTRA_LARGE_CLOSE_BUTTON_SIZE,
    padding: 38
  }
};
var CloseButton = (0, _styledComponents.default)(_UIDialogButton.default).withConfig({
  displayName: "UICloseButton__CloseButton",
  componentId: "sc-171ru7x-0"
})(_templateObject(), function (props) {
  return (0, _Style.remCalc)(SIZE_OPTIONS[props.size]['size']);
}, (0, _Style.remCalc)(_sizes.MODAL_CLOSE_BUTTON_OFFSET), function (props) {
  return (0, _Style.remCalc)(SIZE_OPTIONS[props.size]['size']);
}, function (props) {
  return (0, _Style.remCalc)(SIZE_OPTIONS[props.size]['padding']);
});

var CloseIcon = _styledComponents.default.svg.withConfig({
  displayName: "UICloseButton__CloseIcon",
  componentId: "sc-171ru7x-1"
})(_templateObject2());

var CloseIconInner = _styledComponents.default.path.withConfig({
  displayName: "UICloseButton__CloseIconInner",
  componentId: "sc-171ru7x-2"
})(_templateObject3());

var renderedCloseIcon = _react.default.createElement(CloseIcon, {
  viewBox: "0 0 14 14",
  xmlns: "http://www.w3.org/2000/svg"
}, _react.default.createElement(CloseIconInner, {
  d: "M14.5,1.5l-13,13m0-13,13,13",
  transform: "translate(-1 -1)"
}));

var renderCloseIcon = function renderCloseIcon() {
  return renderedCloseIcon;
};

var getStyle = function getStyle(color, style) {
  return (0, _extends2.default)({
    color: color
  }, style);
};

var UICloseButton =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(UICloseButton, _PureComponent);

  function UICloseButton(props) {
    var _this;

    (0, _classCallCheck2.default)(this, UICloseButton);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(UICloseButton).call(this, props));
    _this._getStyle = (0, _memoizeOne.default)(getStyle);
    return _this;
  }

  (0, _createClass2.default)(UICloseButton, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          color = _this$props.color,
          disabled = _this$props.disabled,
          onClick = _this$props.onClick,
          size = _this$props.size,
          style = _this$props.style,
          rest = (0, _objectWithoutProperties2.default)(_this$props, ["className", "color", "disabled", "onClick", "size", "style"]);
      var computedSize = TShirtSize.fromProp(size).long;
      return _react.default.createElement(CloseButton, (0, _extends2.default)({}, rest, {
        "aria-label": _I18n.default.text('salesUI.UICloseButton.label'),
        className: (0, _classNames.default)('private-close__button', className, {
          'private-close__button--disabled': disabled
        }),
        "data-action": "close",
        disabled: disabled,
        IconHolder: renderCloseIcon,
        onClick: onClick,
        size: computedSize,
        style: this._getStyle(color, style)
      }));
    }
  }]);
  return UICloseButton;
}(_react.PureComponent);

UICloseButton.propTypes = {
  color: _react.PropTypes.string,
  disabled: _react.PropTypes.bool.isRequired,
  size: TShirtSize.propTypeForSizes(['sm', 'md', 'lg', 'xl'])
};
UICloseButton.defaultProps = {
  disabled: false,
  size: 'large'
};
UICloseButton.displayName = 'UICloseButton';
var _default = UICloseButton;
exports.default = _default;
module.exports = exports.default;